import React, { useEffect } from 'react'
// import '../../Components/css/LoginPageStyle.css';
import './ParticipantReview.css';

const ParticipantReview = (props) => {
    const { productObjective, whoIsItFor, getProductDetail, productId } = props;

    useEffect(() => {
        getProductDetail(productId);
    }, [productObjective,whoIsItFor])

    return (
        <div className="product-details">
            <div className="ParticipantReviewWrapper">
                <div className="ObjectiveWrapper">
                    <h5>Objective of the Product</h5>
                    <p>
                        {productObjective}
                    </p>
                </div>
                <div className="ObjectiveWrapper">
                    <h5>Who is it for?</h5>
                    <p>
                        {whoIsItFor}
                    </p>
                </div>
            </div>
            
            <button><b>Start Review</b></button>
        </div>
    )
}

export default ParticipantReview;
